var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.014,
    height: 15,
    viewBox: "0 0 13.014 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Flag",
    d: "M6.626,2A7.156,7.156,0,0,0,4.1,2.39c-.445.168-1.1.463-1.1.993V16.3a.725.725,0,0,0,.745.7.725.725,0,0,0,.745-.7V11.919a5.142,5.142,0,0,1,2.136-.357,7.179,7.179,0,0,1,2.6.629,8.938,8.938,0,0,0,3.158.73,7.156,7.156,0,0,0,2.527-.39c.448-.169,1.1-.461,1.1-.993V3.383a.7.7,0,0,0-.46-.65.779.779,0,0,0-.795.137,1.6,1.6,0,0,1-.4.2,5.623,5.623,0,0,1-1.974.29,7.181,7.181,0,0,1-2.6-.629A8.937,8.937,0,0,0,6.626,2ZM4.49,3.763c.046-.021.1-.044.162-.067a5.623,5.623,0,0,1,1.974-.29,7.18,7.18,0,0,1,2.6.629,8.937,8.937,0,0,0,3.158.73A7.825,7.825,0,0,0,14.524,4.5v6.655a5.142,5.142,0,0,1-2.136.357,7.179,7.179,0,0,1-2.6-.629,8.938,8.938,0,0,0-3.158-.73,7.827,7.827,0,0,0-2.136.261Z",
    transform: "translate(-3 -2)",
    fill: "#f1f1f1",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.5314d64b1d8379539f690b296d42c02e.svg";
export { ForwardRef as ReactComponent };